export default __webpack_public_path__ + "static/farger1-f803c30b8283c2c6f2c6bd15757735b6.png";